<script lang="ts">
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import Chart from "chart.js";
import { HorizontalBar } from "vue-chartjs";

/**
 * Chartjs Barコンポーネント
 */
@Component
export default class BarChart extends Mixins(HorizontalBar) {
  /** グラフに表示する内容 */
  @Prop({
    default: () => {
      return {};
    }
  })
  chartData!: Chart.ChartData;

  /**
   * vue lifecycle created
   */
  public created(): void {
    return;
  }

  /**
   * vue lifecycle mounted
   */
  public mounted(): void {
    const _this: BarChart = this;
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
              callback: function (value: any, index: any, values: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }
          }
        ]
      },
      // ツールチップ
      tooltips: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "rgba(0, 0, 0, .2)",
        borderWidth: 1,
        titleFontColor: "rgba(0, 0, 0, 1)",
        titleFontSize: 14,
        bodyFontColor: "rgba(0, 0, 0, 1)",
        bodyFontSize: 14,
        bodySpacing: 8,
        xPadding: 8,
        yPadding: 12,
        // ツールチップラベルを変更する
        callbacks: {
          // タイトルは消す
          title: function () {
            return ""; // 空の文字列を返す
          },
          label: function (tooltipItem: Chart.ChartTooltipItem, data: any) {
            return _this.createTooltipLabel(tooltipItem, data);
          }
        }
      },
      legend: {
        display: false
      }
    });

    return;
  }

  /**
   * propの値が更新されたらグラフを再描画する
   * chartjsのグラフ再描画を使用すると、高さがリセットされるようなので自前で行う
   */
  @Watch("chartData")
  public chartDataChanged(): void {
    const _this: BarChart = this;
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
              callback: function (value: any, index: any, values: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }
          }
        ]
      },
      // ツールチップ
      tooltips: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "rgba(0, 0, 0, .2)",
        borderWidth: 1,
        titleFontColor: "rgba(0, 0, 0, 1)",
        titleFontSize: 14,
        bodyFontColor: "rgba(0, 0, 0, 1)",
        bodyFontSize: 14,
        bodySpacing: 8,
        xPadding: 8,
        yPadding: 12,
        // ツールチップラベルを変更する
        callbacks: {
          // タイトルは消す
          title: function () {
            return ""; // 空の文字列を返す
          },
          label: function (tooltipItem: Chart.ChartTooltipItem, data: any) {
            return _this.createTooltipLabel(tooltipItem, data);
          }
        }
      },
      legend: {
        display: false
      }
    });

    return;
  }

  /**
   * ツールチップのラベルを作成する
   */
  public createTooltipLabel(tooltipItem: Chart.ChartTooltipItem, data: any): string {
    let label: string = "";

    if (tooltipItem.index != undefined) {
      const index: number = tooltipItem.index;
      label = data.labels[index];

      if (label) {
        label = `${label}`;
      }
    }

    return label;
  }
}
</script>
